module.exports = __webpack_public_path__ + "static/img/warning.41c3036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warning.png
// module id = Ufxh
// module chunks = 1